let debounces = 0

export default function debounce (fn, delay) {
  let timer = null
  return function debouncer (...args) {
    const context = this
    if (timer === null) {
      debounces += 1
    }
    clearTimeout(timer)
    timer = setTimeout(() => {
      debounces -= 1
      timer = null
      fn.apply(context, args)
    }, delay)
  }
}

export function debouncing () {
  return debounces > 0
}
